import PropTypes from 'prop-types';
import i18n from 'i18next';

import { TableAction } from '../../TableAction.component';
const BUTTON_PREFIX = 'commons.buttons.actions-buttons';

export function ViewTableAction({ onView, ...props }) {
  return (
    <TableAction
      tooltip={i18n.t(`${BUTTON_PREFIX}.view`)}
      iconName="eye"
      onClick={onView}
      {...props}
    />
  );
}

ViewTableAction.propTypes = {
  onView: PropTypes.func,
};
